import {useState, useCallback} from "react";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {addMessage, clearThread} from "../chatSlice";
import {useNavigate} from "react-router-dom";
import {chatApi} from "../chatApi";
import {MessageWithMetadata} from "../../../types";
import IconDibLogoWhite from "../../../assets/dib-logo-white.svg?react";
import {TopSplashInput} from "./TopSplashInput";
import classes from "./TopChatSplashView.module.css";

const initialUserMessage = {
    role: "user",
    content: "",
    position: 0,
    sources: [],
    isRegenerated: false,
    timestamp: new Date().toISOString(),
    thoughts: [],
    activities: [],
    pluginActivities: [],
    relatedTools: [],
} as MessageWithMetadata;

const initialAssistantMessage = {
    role: "assistant",
    content: "",
    position: 1,
    sources: [],
    isRegenerated: false,
    timestamp: new Date().toISOString(),
    thoughts: [],
    activities: [],
    pluginActivities: [],
    relatedTools: [],
};

const systemName = "DIB";

export const TopChatSplashView = () => {
    const [sendMessage] = chatApi.endpoints.sendMessage.useMutation();
    const chosenResponseType = useAppSelector(
        (state) => state.session.chosenResponseType
    );

    const [value, setValue] = useState("");
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const handleSendMessage = useCallback(
        (message: string) => {
            dispatch(clearThread());

            navigate(`/chat/new`);

            // Immediately add temporary messages to the thread
            dispatch(
                addMessage({
                    ...initialUserMessage,
                    content: message,
                    timestamp: new Date().toISOString(),
                } as MessageWithMetadata)
            );
            dispatch(
                addMessage({
                    ...initialAssistantMessage,
                    responseType: chosenResponseType,
                    timestamp: new Date().toISOString(),
                } as MessageWithMetadata)
            );

            sendMessage({
                system: {name: systemName},
                message,
                onThreadIdReceived: (threadId) => {
                    navigate(`/chat/${threadId}`, {
                        replace: true,
                        state: {from: "/"},
                    });
                },
            });
        },
        [navigate, sendMessage, chosenResponseType, dispatch]
    );

    return (
        <div className={classes.background}>
            <div className={classes.content}>
                <IconDibLogoWhite className={classes.logo} />
                <div className={classes.field}>
                    <TopSplashInput
                        value={value}
                        onSendMessage={handleSendMessage}
                        onValueChange={setValue}
                    />
                </div>
            </div>
        </div>
    );
};
